/**
 * Holds the Three.js scene contents and forwards lifecycle updates to entities.
 * Physics remains a separate system; the world only ties entities to the scene.
 */
export class World {
  constructor({ scene, physics }) {
    this.scene = scene;
    this.physics = physics;
    this.entities = new Set();
  }

  add(entity) {
    if (!entity || this.entities.has(entity)) return entity;

    this.entities.add(entity);
    entity.world = this;
    if (entity.mesh) this.scene.add(entity.mesh);
    return entity;
  }

  remove(entity) {
    if (!entity || !this.entities.delete(entity)) return;

    if (entity.mesh) entity.mesh.removeFromParent();
    if (entity.body) this.physics.removeBody(entity.body);
    entity.world = null;
  }

  clear() {
    for (const entity of [...this.entities]) this.remove(entity);
  }

  fixedUpdate(dt) {
    for (const entity of this.entities) entity.fixedUpdate(dt);
  }

  lateUpdate(dt) {
    for (const entity of this.entities) entity.lateUpdate(dt);
  }
}
